/*@flow*/

export const defaultPopUpOptions = {
  className: 'my-popup',
  closeButton: true,
  maxWidth: 210,
  minWidth: 210,
  maxHeight: 300,
  autoPan: true,
  enabled: false,
};

export type PopupOptionsT = {
  minWidth?: number,
  maxWidth?: number,
  className?: string,
  closeButton?: boolean,
  maxHeight?: number,
  autoPan?: boolean,
  enabled?: boolean,
  component?: Class<React$Component<>>,
};

export type WithPopup<T> = T & {
  openPopup: Function,
  bindPopup: Function,
  unbindPopup: Function,
  closePopup: Function,
};
